const Dash = <>&mdash;</>;

export default Dash;
